import { handleResponse } from "utils/axios";
import { axiosInstance } from "./index";
import { onGetDefaultServiceFee, onPost } from "mocksdata/setting";
/*Change Get Api here*/
const getDefaultServiceFee = async () => {
  onGetDefaultServiceFee();
  return axiosInstance({
    method: "get",
    url: "/settings/default-service-fee",
  }).then(handleResponse);
};

/**
 * @param {{ serviceFee: number }} data
 * @returns {Promise<object>}
 * */
const updateDefaultServiceFee = async (data) => {
  onPost(data);
  console.log(data);
  return await axiosInstance.post("/settings/service-fee", data).then(handleResponse);
};

const getAutoApproval = async () => {
  return axiosInstance.get(`/settings/auto-approval`).then(handleResponse);
};

const updateAutoApproval = async (data) => {
  return axiosInstance.put(`/settings/auto-approval`, data).then(handleResponse);
};

export { getDefaultServiceFee, updateDefaultServiceFee, getAutoApproval, updateAutoApproval };
